<template>
  <div class="header-wrapper"
  :class="{
    'dark': isDark,
  }">
    <header
      class="main-header"
      :class="{
        'is-fixed': fixedMenu && isFixed,
        'is-open': fixedMenu && isOpen,
        'menu-fixed': fixedMenu
      }"
    >
      <div class="page-container">
        <div class="left logo" @click="$emit('logoClick')">
          <slot></slot>
        </div>
        <div class="right">
          <HeaderOptions v-if="!fixedMenu || !isPhone" :tiles="tiles" :loginButton="loginButton" :clipboard="clipboard" />
          <button type="button" class="hamburger" @click="hamburgerClick" :title="buttonData.menuToggle">
            <svg>
              <use xlink:href="#hamburgerSvg"></use>
            </svg>
          </button>
        </div>
      </div>
    </header>
    <transition name="bottombar">
      <div class="mobile-bottom-menu" v-if="fixedMenu && isPhone && showMobileBottmoBar">
        <div class="page-container">
          <HeaderOptions :loginButton="loginButton" :tiles="tiles" :clipboard="clipboard" />
          <ScrollToNext />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HeaderOptions from '@/components/HeaderOptions.vue'
import ScrollToNext from '@/components/ScrollToNext.vue'

export default {
  name: 'mainHeader',
  props: ['dark', 'tiles', 'loginButton', 'fixedMenu', 'clipboard'],
  components: {
    HeaderOptions,
    ScrollToNext
  },
  data: function () {
    return {
      customSelectOpen: false,
      ticking: false,
      isFixed: false,
      isOpen: false,
      lastScrollY: 0,
      windowHeight: 0,
      scrollDirectionIsBottom: true,
      isInFirstScreen: true,
      showMobileBottmoBar: true
    }
  },
  methods: {
    ...mapActions([
      'incrementFontSize',
      'decrementFontSize',
      'toggleContrast',
      'toggleMainNav',
      'togglePageNav'
    ]),
    hamburgerClick () {
      this.$router.push({ 'path': '/' })
    },
    handleScroll (event) {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          if (window.pageYOffset < 100) {
            this.showMobileBottmoBar = true
          } else {
            this.showMobileBottmoBar = false
          }
          if (window.pageYOffset > this.windowHeight) {
            this.isFixed = true
            this.isInFirstScreen = false
          } else {
            this.isInFirstScreen = true
            this.isFixed = false
            this.isOpen = false
          }
          if (window.pageYOffset > this.lastScrollY + 10) {
            this.lastScrollY = window.pageYOffset
            this.scrollDirectionIsBottom = true
            this.isOpen = false
          }
          if (window.pageYOffset < this.lastScrollY - 10) {
            this.lastScrollY = window.pageYOffset
            this.scrollDirectionIsBottom = false
            if (!this.isInFirstScreen) {
              this.isOpen = true
            }
          }
          this.ticking = false
        })
        this.ticking = true
      }
    }
  },
  computed: {
    ...mapGetters([
      'fontSize',
      'fontSizeMax',
      'fontSizeMin',
      'contrast',
      'availableTranslations',
      'selectedTranslation',
      'pageNavOpen',
      'breakpoint',
      'buttonData'
    ]),
    translations () {
      return this.availableTranslations.filter(el => el !== this.selectedTranslation)
    },
    isDark () {
      return this.isFixed ? false : this.dark
    },
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  },
  created () {
    if (this.fixedMenu) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  mounted () {
    this.windowHeight = document.documentElement.clientHeight || document.documentElement.getElementsByTagName('body')[0].clientHeight || window.innerHeight
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="scss">
  .header-wrapper {
    position: absolute;
    z-index: 9999999;
    top: 0;
    left: 0;
    width: 100%;
  }
  .logo {
    cursor: pointer;
  }
  .main-header,
  .main-header.dark {
    background-color: transparent;
    z-index: 99999;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0;
    width: 100%;
    background-color: transparent;
    z-index: 9999999;
    transform: translateY(0);
    padding: 30px 0;
    .page-container {
      max-width: 88vw;
      padding: 0;
      // min-height: 84px;
    }
    .virtual & {
      position: static;
    }
    &.menu-fixed {
      position: absolute;
      top: 0;
      left: 0;
      padding: 0;
      width: 100%;
      background-color: transparent;
      z-index: 9999999;
      transform: translateY(0);
      padding: 30px 0;
      .page-container {
        max-width: 88vw;
        max-width: calc(88vw + 15px);
        padding: 0;
        // min-height: 84px;
      }
      &.is-fixed {
        position: fixed;
        transition: $transitionMenu;
        opacity: 0;
        background-color: $bg-light;
        transform: translateY(-150%);
      }
      &.is-fixed.is-open {
        opacity: 1;
        transform: translateY(0);
      }
      @include tablet {
        min-height: 84px;
        .page-container {
          max-width: 88vw;
        }
      }
      @include mobile {
        padding: 20px 0;
      }
    }
    @include mobile {
      position: relative;
      min-height: 46px;
      width: 100%;
      .right {
        position: static;
        top: 0;
        left: 0;
        width: 100%;
        // height: calc(100vh - 100px);
        // transform: translateY(92vh);
        display: flex;
        align-items: flex-end;
        z-index: 999;
        .hamburger {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
      .left {
        position: absolute;
        top: 0;
        left: 0;
      }
      .virtual & {
        position: fixed;
        transform: none;
        .page-container {
          position: static;
        }
        .right {
          position: static;
          top: auto;
          bottom: 6vw;
          left: 6vw;
          z-index: 999;
          float: none;
          display: block;
          align-items: initial;
          align-content: initial;
          * {
            pointer-events: initial;
          }
          // width: auto;
          // height: auto;
          .hamburger {
            position: fixed;
            top: 20px;
            right: 6vw;
          }
          .header-options {
            position: fixed;
            left: 6vw;
            left: calc(6vw - 10px);
            top: auto;
            bottom: 12px;
            z-index: 999999;
            transform: translate3d(0,0,0);
          }
        }
        .left {
          position: fixed;
          top: 20px;
          left: 6vw;
        }
      }
      // .virtual & {
      //   min-height: 46px;
      //   .right {
      //     position: fixed;
      //     bottom: 20px;
      //     left: 20px;
      //     z-index: 999;
      //     .hamburger {
      //       position: fixed;
      //       top: 20px;
      //       right: 20px;
      //     }
      //   }
      //   .left {
      //     position: fixed;
      //     top: 20px;
      //     left: 20px;
      //   }
      // }
      .custom-select {
        .options {
          top: 0;
          transform: translateY(-100%);
        }
      }
    }
  }
  h2 {
    text-align: left;
    text-transform: uppercase;
    font-size: $font-l;
    strong {
      font-size: $font-xl;
      display: block;
    }
  }
  header {
    @include clearfix;
  }
  .left {
    float: left;
    text-align: left;

    a,
    svg,
    img {
      display: inline-block;
      height: auto;
      max-height: 46px;
      width: 100%;
      max-width: 168px;
    }
    a {
      /deep/ svg {
        height: auto;
        max-height: 46px;
        width: 100%;
        max-width: 168px;
      }
    }
  }
  .right {
    float: right;
    display: flex;
    align-content: center;
    align-items: center;
    transition: $transition;
    button {
      &:hover {
        @include biger-then-tablet {
          transform: scale(1.2);
        }
      }
    }
  }
  button {
    background-color: transparent;
    box-shadow: none;
    display: flex;
    align-content: center;
    align-items: center;
    cursor: pointer;
    color: $text-dark;
    border: none;
    vertical-align: middle;
    user-select: none;
    font-weight: 600;
    font-size: $font-s;
    margin-left: 4px;
    padding: 1px 6px;
    .use-default,
    .use-hover {
      display: none;
    }
    .dark & {
      .use-dark {
        display: none;
      }
      .use-default {
        display: block
      }
    }
    svg {
      max-width: 100%;
      max-height: 100%;
      height: 14px;
      width: 14px;
    }
    &:focus {
      outline: none;
    }
    &:hover {
      @include biger-then-tablet {
        color: $text-accent;
        .use-hover {
          display: block;
        }
        .use-default {
          display: none;
        }
        .use-dark {
          display: none;
        }
      }
    }
    &:disabled {
      cursor: auto;
      opacity: 0.4;
      color: inherit;
    }
    .dark & {
      color: $text-light;
      &:hover {
        @include biger-then-tablet {
          color: $text-accent;
        }
        &:disabled {
          color: inherit;
        }
      }
    }
  }
  .mobile-bottom-menu {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 99999999;
    background-color: $body-bg;
    .header-options {
      width: 88vw;
      width: calc(88vw + 20px);
      margin: 0 auto;
      transform: translateX(-10px);
    }
    .hight-contrast & {
      background-color: $bg-dark;
    }
    .page-container {
      padding: 12px 0;
      max-width: 88vw;
    }
    .button-scroll {
      top: 0;
      right: 0;
      padding: 10px;
    }
  }
  .button-font {
    height: 30px;
    padding: 1px 6px;
    &:first-child {
      padding: 1px 0 1px 6px;
    }
  }
  .custom-select {
    text-transform: uppercase;
    vertical-align: middle;
    display: inline-block;
    position: relative;
    min-width: 30px;
    margin-left: 4px;
    button {
      text-transform: uppercase;
      padding: 5px 6px;
      margin: 0;
      svg {
        height: 10px;
        width: 10px;
        margin-left: 3px;
      }
    }
    .options {
      position: absolute;
      top: 100%;
      left: 0;
      list-style: none;
      margin: 0;
      padding: 4px 0;
      min-width: 100%;
      li {
        font-weight: 600;
        font-size: 14px;
        text-transform: uppercase;
        text-align: left;
        margin: 5px 0;
        padding: 0 6px;
        cursor: pointer;
      }
    }
  }
  .button-contrast {
    width: 30px;
    height: 30px;
    padding: 1px 6px;
    // overflow: hidden;
    // color: transparent !important;
    // font-size: 0;
    // background-image: url(../assets/images/icons/contrast.svg);
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: 14px 14px;
    // .dark & {
    //   background-image: url(../assets/images/icons/contrast_white.svg);
    // }
  }
  .tiles {
    width: 30px;
    height: 30px;
  }
  .hamburger {
    width: 30px;
    height: 30px;
    &:hover {
      span {
        background-color: $text-accent;
      }
    }
    .dark & {
      &:hover {
        span {
          background-color: $text-accent;
        }
      }
    }
  }
  .bottombar-enter-active {
    transition: opacity .3s;
    animation-name: bottombar;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    animation-duration: 1.1s;
  }
  .bottombar-leave-active {
    transition: opacity 2s;
    animation-name: bottombar;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    animation-duration: 1.1s;
    animation-direction: alternate-reverse;
  }
  .bottombar-enter, .bottombar-leave-to{
    opacity: 0;
  }
  @keyframes bottombar
  {
    0%
    {
      transform: translateY(100%);
    }
    100%
    {
      transform: translateY(0);
    }
  }
</style>
